import { render, staticRenderFns } from "./CitySwitcher.vue?vue&type=template&id=001c04c6"
import script from "./CitySwitcher.vue?vue&type=script&lang=js"
export * from "./CitySwitcher.vue?vue&type=script&lang=js"
import style0 from "./CitySwitcher.vue?vue&type=style&index=0&id=001c04c6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports